<template>
    <div id="app">

        <!-- This will be reaplced by the view defined in the router -->
        <router-view></router-view>

        <!--<footer @click="$helpers.ScrollTo('body')">
            <p>{{new Date().getFullYear()}} Cena</p>
        </footer>-->

        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <Clarity/>

        <KwPixel v-if="$store.state.formSuccess"/>
    </div>
</template>

<script>
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import Clarity from '@/components/Clarity.vue';

export default {
    components: {
        KwPixel,
        ModalContainer,
        Terms,
        Clarity,
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
        const data = {
            url: 'inquerito-kantar.com',
            pubid: this.pubid,
            utm_source: this.$route.query.utm_source,
            utm_campaign: this.$route.query.utm_campaign,
            utm_medium: this.$route.query.utm_medium,
            utm_content: this.$route.query.utm_content,
            utm_term: this.$route.query.utm_term,
            ua_device: this.$store.state.ua_device,
            ua_browser: this.$store.state.ua_browser,
            ua_os: this.$store.state.ua_os,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => console.log(error));
    },
};
</script>
<style>

</style>
